import { render, staticRenderFns } from "./ViewProfile.vue?vue&type=template&id=249def36&scoped=true"
import script from "./ViewProfile.vue?vue&type=script&lang=ts"
export * from "./ViewProfile.vue?vue&type=script&lang=ts"
import style0 from "./ViewProfile.vue?vue&type=style&index=0&id=249def36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249def36",
  null
  
)

export default component.exports